import { render, staticRenderFns } from "./CompanySalary.vue?vue&type=template&id=7a2c982e&"
import script from "./CompanySalary.vue?vue&type=script&lang=js&"
export * from "./CompanySalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports